import React, { useState, useEffect } from "react";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import SettingsPageHeading from "../components/pages/SettingsPageHeading";
import { useOutletContext } from "react-router-dom";
import { getEmailUpdates, updateEmailUpdates } from "../api/user";
import { toast } from "react-toastify";

// Settings → Email updates: the account's marketing email preference (Loops).
// Same layout and switch as Page tips (/guide). Account emails - codes,
// password resets, league emails - are not affected by this switch.
const EmailUpdates = () => {
  const [enabled, setEnabled] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);

  const [sidebarToggle] = useOutletContext();

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await getEmailUpdates();
        if (response.data.success && response.data.status === 200) {
          setEnabled(!!response.data.email_updates);
        }
      } catch (error) {
        console.log("Error fetching email updates:", error);
      } finally {
        setLoaded(true);
      }
    };

    fetchStatus();
  }, []);

  const handleToggle = async () => {
    if (!loaded || saving) return;
    const newStatus = !enabled;
    setEnabled(newStatus);
    setSaving(true);

    try {
      const response = await updateEmailUpdates({ email_updates: newStatus });
      setEnabled(!!response.data.email_updates);
      toast.success("Email updates saved.");
    } catch (error) {
      console.log("Update failed:", error);
      setEnabled(!newStatus);
      toast.error("Could not save Email updates. Try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={"Email updates"} showDesktopTitle={false} />

      <PageContainer>
        <div className="px-4 pt-4 md:pt-10 md:px-0 md:max-w-[55rem] md:mx-auto">
          <SettingsPageHeading
            title="Email updates"
            subtitle="Choose whether QUSHi sends you email updates."
            className="mb-3 md:mb-4"
          />
          <div className="md:rounded-2xl md:border md:border-gray-200 md:bg-white md:p-8">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="font-medium text-gray-800">Email updates</p>
                <p className="mt-0.5 text-sm text-secondary">
                  Account emails, like verification codes, are always sent.
                </p>
              </div>

              <div
                onClick={handleToggle}
                role="switch"
                aria-checked={enabled}
                aria-label="Email updates"
                className="w-14 h-7 rounded-full flex items-center cursor-pointer transition-all shrink-0"
                style={{
                  backgroundColor: enabled ? "#35b23c" : "#d3d3d3",
                  justifyContent: enabled ? "flex-end" : "flex-start",
                  padding: "3px",
                  opacity: loaded ? 1 : 0.5,
                }}
              >
                <div className="w-6 h-6 bg-white rounded-full shadow" />
              </div>
            </div>
          </div>
        </div>
      </PageContainer>
    </>
  );
};

export default EmailUpdates;
